const ContactPage = () =>{

    return (<p>contact</p>        );
}

export default ContactPage;


